module.exports = __webpack_public_path__ + "static/fb_banner_koronica-c36928202134168d53152ea45429a9dd.png";